var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("a", { staticClass: "logo-login", attrs: { href: "#" } }, [
      _c("span", { staticClass: "app-name" }, [_vm._v("Bracket")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }